module.exports = __webpack_public_path__ + "static/media/new-login.944cede3.png";